import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';

import useAuth from '@hooks/use-auth';
import { useSidebar } from '@contexts/SidebarContext';

import AppMenu from '@components/AppMenu';
import AvatarMenu from '@components/AvatarMenu';

import styles from './styles.module.scss';

const { Header, Content } = Layout;

const AdminLayout = () => {
  const { collapsed } = useSidebar();
  let { isAuthenticating, data } = useAuth();

  let location = useLocation();

  if (isAuthenticating) {
    return null;
  }

  if (!data) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  const { permissions, photoURL, displayName } = data;

  if (permissions.length === 1 && permissions[0] === 'finance') {
    return <Navigate to="/financial" replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        className={styles.header}
        style={{
          position: 'fixed',
          zIndex: 100,
          width: '100%',
          height: 64,
          padding: '0 24px',
          top: 0,
          display: 'flex',
          justifyContent: 'flex-end', // Changed to flex-end
          alignItems: 'center',
          backgroundColor: '#fff',
          borderBottom: '1px solid #f0f0f0',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)', // Optional: adds subtle shadow
        }}
      >
        <AvatarMenu photoUrl={photoURL} displayName={displayName} />
      </Header>
      <AppMenu />
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 250,
          marginTop: 64,
          transition: 'all 0.2s',
        }}
      >
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            transition: 'margin-left 0.2s',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
